import { createRouter, createWebHistory } from "vue-router";

import Home from '../components/Home';
import LeadCapture from '../components/LeadCapture';

import Admin_Home from '../components/Admin';
import Admin_Agregar_Proveedor from '../components/Admin_Agregar_Proveedor';
import Admin_Combinar_Clientes from '../components/Admin_Combinar_Clientes';
import Admin_Corte from '../components/Admin_Corte';
import Admin_Inventario from '../components/Admin_Inventario';
import Admin_Leads from '../components/Admin_Leads';
import Admin_Ordenes from '../components/Admin_Ordenes';
import Admin_Pricing from '../components/Admin_Pricing';
import Admin_Pricing_Detail from '../components/Admin_Pricing_Detail';
import Admin_Pricings from '../components/Admin_Pricings';
import Admin_Recolecciones from '../components/Admin_Recolecciones';
import Admin_Proveedor from '../components/Admin_Proveedor';
import Admin_Proveedores from '../components/Admin_Proveedores';
import Admin_Remision from '../components/Admin_Remision';

import Admin_Proveedor_Cliente from '../components/Admin_Proveedor_Cliente';
import Admin_Proveedor_Entrada from '../components/Admin_Proveedor_Entrada';
import Admin_Proveedor_Entradas from '../components/Admin_Proveedor_Entradas';
import Admin_Proveedor_Orden from '../components/Admin_Proveedor_Orden';
import Admin_Proveedor_Producto from '../components/Admin_Proveedor_Producto';
import Admin_Proveedor_Productos from '../components/Admin_Proveedor_Productos';
import Admin_Proveedor_Recibos from '../components/Admin_Proveedor_Recibos';
import Admin_Proveedor_Recibo from '../components/Admin_Proveedor_Recibo';

import Cliente from '../components/Cliente';
import Cliente_Orden from '../components/Cliente_Orden';

import Proveedor_Cliente_Agregar_Orden from '../components/Proveedor_Cliente_Agregar_Orden';
import Proveedor_Configuracion from '../components/Proveedor_Configuracion';
import Proveedor_Recolecciones from '../components/Proveedor_Recolecciones';
import Recoleccion_Detalle from '../components/Recoleccion_Detalle';

import Proveedor from '../components/Proveedor';
import Proveedor_Catalogo from '../components/Proveedor_Catalogo';
import Proveedor_Cliente from '../components/Proveedor_Cliente';
import Proveedor_Cliente_Productos from '../components/Proveedor_Cliente_Productos';
import Proveedor_Clientes from '../components/Proveedor_Clientes';
import Proveedor_Direccion from '../components/Proveedor_Direccion';
import Proveedor_Direcciones from '../components/Proveedor_Direcciones';
import Proveedor_Editar_Cliente from '../components/Proveedor_Editar_Cliente';
import Proveedor_Ordenes from '../components/Proveedor_Ordenes';
import Proveedor_Producto_Precio from '../components/Proveedor_Producto_Precio';
import Proveedor_Shopify from '../components/Proveedor_Shopify';

let admin = [{
	path: '/admin/pricing/:pricing_id',
	name: "Admin_Pricing_Detail",
	component: Admin_Pricing_Detail,
	meta: {
		title: 'Esquema de precios',
	}
},{
	path: '/admin/pricing',
	name: "Admin_Pricing",
	component: Admin_Pricing,
	meta: {
		title: 'Crear esquema de precios',
	}
},{
	path: '/admin/pricings',
	name: "Admin_Pricings",
	component: Admin_Pricings,
	meta: {
		title: 'Esquemas de precios',
	}
},{
	path: '/admin/leads',
	name: "Admin_Leads",
	component: Admin_Leads,
	meta: {
		title: 'Leads',
	}
},{
	path: '/admin/recolecciones/:recoleccion_id',
	name: "Admin_Recoleccion",
	component: Recoleccion_Detalle,
	meta: {
		title: 'Recolección',
	}
},{
	path: '/admin/recolecciones',
	name: "Admin_Recolecciones",
	component: Admin_Recolecciones,
	meta: {
		title: 'Recolecciones',
	}
},{
	path: '/admin/recibos', 
	name: "Admin_Recibos",
	component: Admin_Proveedor_Recibos,
	meta: {
		title: 'Admin recibos',
	}
},{ 
	path: '/admin/recibo/:recibo_id', 
	name: "Admin_Recibo",
	component: Admin_Proveedor_Recibo,
	meta: {
		title: 'Admin recibo',
	}
},{ 
	path: '/admin/proveedores', 
	name: "Admin_Proveedores",
	component: Admin_Proveedores,
	meta: {
		title: 'Proveedores',
	}
},{ 
	path: '/admin/combinar_clientes', 
	name: "Admin_Combinar_Clientes",
	component: Admin_Combinar_Clientes,
	meta: {
		title: 'Combinar Clientes',
	}
},{ 
	path: '/admin/corte', 
	name: "Admin_Corte",
	component: Admin_Corte,
	meta: {
		title: 'Corte',
	}
},{ 
	path: '/admin/proveedor/:proveedor_id', 
	name: "Admin_Proveedor",
	component: Admin_Proveedor,
	meta: {
		title: 'Proveedor',
	}
},{ 
	path: '/admin/orden/:orden_id', 
	name: "Admin_Orden",
	component: Admin_Proveedor_Orden,
	meta: {
		title: 'Admin_Orden',
	}
},{ 
	path: '/admin/proveedor', 
	name: "Admin_Agregar_Proveedor",
	component: Admin_Agregar_Proveedor,
	meta: {
		title: 'Agregar proveedor',
	}
},{ 
	path: '/admin/ordenes', 
	name: "Admin_Ordenes",
	component: Admin_Ordenes,
	meta: {
		title: 'Ordenes',
	}
},{ 
	path: '/admin/entrada/', 
	name: "Admin_Entrada_Agregar",
	component: Admin_Proveedor_Entrada,
	meta: {
		title: 'Entrada',
	}
},{ 
	path: '/admin/entrada/:entrada_id', 
	name: "Admin_Entrada",
	component: Admin_Proveedor_Entrada,
	meta: {
		title: 'Entrada',
	}
},{ 
	path: '/admin/entradas', 
	name: "Admin_Entradas",
	component: Admin_Proveedor_Entradas,
	meta: {
		title: 'Entradas',
	}
},{ 
	path: '/admin/orden/:orden_id/remision', 
	name: "Admin_Remision",
	component: Admin_Remision,
	meta: {
		title: 'Remision',
	}
},{ 
	path: '/admin/cliente/:cliente_id', 
	name: "Admin_Cliente",
	component: Proveedor_Editar_Cliente,
	meta: {
		title: 'Cliente',
	}
},{ 
	path: '/admin/inventario', 
	name: "Admin_Inventario",
	component: Admin_Inventario,
	meta: {
		title: 'Admin Intventario',
	}
},{ 
	path: '/admin', 
	name: "Admin_Home",
	component: Admin_Home,
	meta: {
		title: 'Admin dashboard',
	}
},{ 
	path: '/admin/proveedor_cliente', 
	name: "Admin_Proveedor_Cliente",
	component: Admin_Proveedor_Cliente,
	meta: {
		title: 'Admin_Proveedor_Cliente',
	}
}]

let proveedor = [{ 
	path: '/proveedor/:proveedor_id/recolecciones/:recoleccion_id',
	name: "Proveedor_Recoleccion",
	component: Recoleccion_Detalle,
	meta: {
		title: 'Recolección',
	}
},{
	path: '/proveedor/:proveedor_id/recolecciones',
	name: "Proveedor_Recolecciones",
	component: Proveedor_Recolecciones,
	meta: {
		title: 'Recolecciones',
	}
},{
	path: '/proveedor/:proveedor_id/configuracion',
	name: "Proveedor_Configuracion",
	component: Proveedor_Configuracion,
	meta: {
		title: 'Configuración',
	}
},{
	path: '/proveedor/:proveedor_id/entrada/:entrada_id', 
	name: "Proveedor_Entrada",
	component: Admin_Proveedor_Entrada,
	meta: {
		title: 'Entrada',
	}
},{ 
	path: '/proveedor/:proveedor_id/entradas', 
	name: "Proveedor_Entradas",
	component: Admin_Proveedor_Entradas,
	meta: {
		title: 'Entradas',
	}
},{ 
	path: '/proveedor/:proveedor_id/cliente/:cliente_id', 
	name: "Proveedor_Cliente",
	component: Proveedor_Cliente,
	meta: {
		title: 'Editar cliente',
	}
},{ 
	path: '/proveedor/:proveedor_id/direccion/:direccion_id', 
	name: "Editar direccion",
	component: Proveedor_Direccion,
	meta: {
		title: 'Dirección',
	}
},{ 
	path: '/proveedor/:proveedor_id/direccion', 
	name: "Crear direccion",
	component: Proveedor_Direccion,
	meta: {
		title: 'Dirección',
	}
},{ 
	path: '/proveedor/:proveedor_id/direcciones', 
	name: "Direcciones",
	component: Proveedor_Direcciones,
	meta: {
		title: 'Direcciones',
	}
},{ 
	path: '/proveedor/:proveedor_id/recibos', 
	name: "Proveedor_Recibos",
	component: Admin_Proveedor_Recibos,
	meta: {
		title: 'Proveedor recibos',
	}
},{ 
	path: '/proveedor/:proveedor_id/recibo/:recibo_id', 
	name: "Proveedor_Recibo",
	component: Admin_Proveedor_Recibo,
	meta: {
		title: 'Proveedor recibo',
	}
},{ 
	path: '/proveedor/:proveedor_id/cliente/:cliente_id/editar', 
	name: "Proveedor_Editar_Cliente",
	component: Proveedor_Editar_Cliente,
	meta: {
		title: 'Editar cliente',
	}
},{ 
	path: '/proveedor/:proveedor_id/cliente', 
	name: "Proveedor_Agregar_Cliente",
	component: Proveedor_Editar_Cliente,
	meta: {
		title: 'Proveedor agregar cliente',
	}
},{ 
	path: '/proveedor/:proveedor_id/catalogo', 
	name: "Proveedor_Catalogo",
	component: Proveedor_Catalogo,
	meta: {
		title: 'Proveedor catalogo',
	}
},{ 
	path: '/proveedor/:proveedor_id/cliente/:cliente_id/productos', 
	name: "Proveedor_Cliente_Productos",
	component: Proveedor_Cliente_Productos,
	meta: {
		title: 'Proveedor cliente productos',
	}
},{ 
	path: '/proveedor/:proveedor_id/producto/:producto_id', 
	name: "Proveedor_Producto",
	component: Admin_Proveedor_Producto,
	meta: {
		title: 'Proveedor proudcto',
	}
},{ 
	path: '/proveedor/:proveedor_id/producto/:producto_id/precio', 
	name: "Proveedor_Agregar_Producto_Precio",
	component: Proveedor_Producto_Precio,
	meta: {
		title: 'Proveedor agregar proudcto precio',
	}
},{ 
	path: '/proveedor/:proveedor_id/producto/:producto_id/precio/:producto_precio_id', 
	name: "Proveedor_Editar_Producto_Precio",
	component: Proveedor_Producto_Precio,
	meta: {
		title: 'Proveedor editar proudcto precio',
	}
},{ 
	path: '/proveedor/:proveedor_id/alta', 
	redirect: to => ({
		name: "Alta",
		query: {
			...to.query,
			proveedor_id: to.params.proveedor_id,
		},
	}),
},{ 
	path: '/alta', 
	name: "Alta",
	component: Proveedor_Editar_Cliente,
	meta: {
		title: 'Alta',
	}
},{ 
	path: '/proveedor/:proveedor_id/producto', 
	name: "Proveedor_Agregar_Producto",
	component: Admin_Proveedor_Producto,
	meta: {
		title: 'Agregar producto',
	}
},{ 
	path: '/proveedor/:proveedor_id/productos', 
	name: "Proveedor_Productos",
	component: Admin_Proveedor_Productos,
	meta: {
		title: 'Productos',
	}
},{
	path: '/proveedor/:proveedor_id/shopify',
	name: "Proveedor_Shopify",
	component: Proveedor_Shopify,
	meta: {
		title: 'Shopify',
	}
},{
	path: '/proveedor/:proveedor_id/ordenes', 
	name: "Proveedor_Ordenes",
	component: Proveedor_Ordenes,
	meta: {
		title: 'Ordenes',
	}
},{ 
	path: '/proveedor/:proveedor_id/orden/:orden_id', 
	name: "Proveedor_Orden",
	component: Admin_Proveedor_Orden,
	meta: {
		title: 'Orden',
	}
},{ 
	path: '/proveedor/:proveedor_id/orden', 
	name: "Proveedor_Agregar_Orden",
	component: Proveedor_Cliente_Agregar_Orden,
	meta: {
		title: 'Agregar orden',
	}
},{ 
	path: '/proveedor/:proveedor_id/clientes', 
	name: "Proveedor_Clientes",
	component: Proveedor_Clientes,
	meta: {
		title: 'Clientes',
	}
},{ 
	path: '/proveedor/:proveedor_id', 
	name: "Proveedor",
	component: Proveedor,
	meta: {
		title: 'Dashboard',
	}
}]

let cliente = [{ 
	path: '/cliente/:cliente_id/orden', 
	name: "Cliente_Agregar_Orden",
	component: Proveedor_Cliente_Agregar_Orden,
	meta: {
		title: 'Agregar orden',
	}
},{ 
	path: '/cliente/:cliente_id', 
	name: "Cliente",
	component: Cliente,
	meta: {
		title: 'Ordenes',
	}
},{ 
	path: '/cliente/:cliente_id/orden/:orden_id', 
	name: "Cliente_Orden",
	component: Cliente_Orden,
	meta: {
		title: 'Ordenes',
	}
}]

let misc = [{ 
	path: '/', 
	name: "Home",
	component: Home
},{
	path: '/contacto',
	name: "Lead_Capture",
	component: LeadCapture,
	meta: {
		title: 'Contacto',
	}
}]

const routes = [admin, proveedor, cliente, misc]

export default createRouter({
	history: createWebHistory(),
	routes: routes.flat()
})
